import { menuData } from "../global/constants"
import { useState, useEffect } from 'react'
import { useTranslation } from "react-i18next";
import { Link as LinkScroll, animateScroll as scroll, scroller } from "react-scroll";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Navigate,
    useNavigate,
    useLocation
} from "react-router-dom";

import axios from 'axios'
import { useSelector, useDispatch } from 'react-redux';


const CountBtn = ({ count, setCount }) => {
    const dispatch = useDispatch()
    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const navigate = useNavigate()
    const location = useLocation()



    // 处理加号按钮点击事件
    const handleIncrement = () => {
        setCount(count + 1);
    };

    // 处理减号按钮点击事件
    const handleDecrement = () => {
        setCount(count - 1);
    };


    useEffect(() => {
        if (count > 0) {

        }
        else {
            setCount(1)
        }

    }, [count]);



    return <div className="relative ">

        <div className=" items-stretch relative flex  text-black border border-solid border-black4 overflow-hidden rounded-md">
            <button className="w-[40px] flex-none aspect-[1/1] bg-[#F0F0F0]" onClick={handleDecrement}>-</button>
            <input
                type="tel"
                className="text-center w-full border-0 p-0 !text-[#534841] !rounded-none"
                value={count > 0 ? Number(count) : ''}
                onChange={(e) => setCount(Number(e.target.value))}
                min={0}
            />
            <button className="w-[40px] flex-none min-h-full  bg-[#F0F0F0]" onClick={handleIncrement}>+</button>


        </div>

    </div>

}
export default CountBtn